module.exports = __webpack_public_path__ + "img/img_15@2x.d85f6522.png";